import User from "@/Models/User";
import { $loaderService } from "@/plugins/ELoaderService";
import router from "@/router";
import store, { limparDadosBasicos, limparTodosOsDados } from "@/store";
// import { $Tawk } from "vue-tawk";

import Axios from "../plugins/Axios";
import { sincronizarTemaComUsuario } from "../plugins/tema";
import { removerInscricaoNoLogout } from "../plugins/webPush";

export class AuthService {
  static ACCESS_TOKEN_NAME = "access_token";

  async logar({ email, password }) {
    await Axios().get("/sanctum/csrf-cookie");
    const response = await Axios().post("/login", {
      email,
      password,
      device_name: this.getDeviceName(),
    });

    // $Tawk.$showWidget();
    this.setAccessToken(response.data);
    $loaderService.loadBasicDataIfNeeded();
    // if (window.Tawk_API.showWidget) window.Tawk_API.showWidget();
    this.syncUserWithStore();

    // this.verificarForcaDaSenha();
    store.dispatch("Auth/verificarForcaDaSenha");
  }

  async solicitarRedefinicaoSenha(login) {
    return Axios().post("/forgot-password", { login });
  }

  async redefinirSenha({ login, token, password, password_confirmation }) {
    return Axios().post("/reset-password", { login, token, password, password_confirmation });
  }

  async verificarForcaDaSenha() {
    await Axios().get("/verificar-forca-da-senha");
  }

  async getCurrentUser() {
    const response = await Axios().get("/current-user");
    return new User(response.data);
  }

  getDeviceName() {
    return `${navigator.appCodeName} - ${navigator.platform}`;
  }

  async logout() {
    // await Axios().get("/logout");
    // antes de apagar o token: este aparelho deixa de receber os avisos desta conta
    await removerInscricaoNoLogout();
    store.commit("Auth/setUser", null);
    limparTodosOsDados();
    localStorage.removeItem(AuthService.ACCESS_TOKEN_NAME);
    $loaderService.close();
    // if (window.Tawk_API.hideWidget) window.Tawk_API.hideWidget();
  }

  setAccessToken(accessTokenObject) {
    localStorage.setItem(AuthService.ACCESS_TOKEN_NAME, accessTokenObject.access_token);
  }

  async syncUserWithStore() {
    if (this.isLoggedIn()) {
      const user = await this.getCurrentUser();

      // if (user) {
      //   const { data: hash } = await Axios().get("tawk-to-hash", { params: { email: user.email } });
      //   const tawkToUser = {
      //     name: user.name,
      //     email: user.email,
      //     hash,
      //   };
      //   try {
      //     $Tawk.$setAttributes(tawkToUser);
      //   } catch (e) {
      //     return;
      //   }
      // }

      store.commit("Auth/setUser", user);
      sincronizarTemaComUsuario(user);
    }
  }

  async atualizarTema(tema) {
    await Axios().put("/current-user/tema", { tema });
    const user = store.getters["Auth/user"];
    if (user) store.commit("Auth/setUser", { ...user, tema });
  }

  async atualizarDatasComemorativas(ativo) {
    await Axios().put("/current-user/datas-comemorativas", { ativo });
    const user = store.getters["Auth/user"];
    if (user) store.commit("Auth/setUser", { ...user, datas_comemorativas: ativo });
  }

  isLoggedIn() {
    return Boolean(this.getAccessToken());
  }

  getAccessToken() {
    try {
      return localStorage.getItem(AuthService.ACCESS_TOKEN_NAME);
    } catch (error) {
      return error;
    }
  }

  async updateCurrentUser(user) {
    const currentUser = store.getters["Auth/user"];
    if (!currentUser || !user) throw new Error("Usuário inexistente");
    const response = await Axios().put(`/users/me`, user);
    const updatedUser = response.data;
    await this.syncUserWithStore();
    // store.commit("Auth/setUser", updatedUser);
    return updatedUser;
  }

  async mudarDeAno(ano) {
    if (!ano) throw new Error("Ano escolhido inválido");
    const currentUser = store.getters["Auth/user"];
    try {
      const response = await this.updateCurrentUser({ ...currentUser, ano_id: ano.id });
      return response;
    } catch (error) {
      throw new Error("Não foi possível efetuar a troca de ano.");
    }
  }

  async mudarDeFranquia(franquia) {
    if (!franquia) throw new Error("Franquia escolhida é inválida");
    const currentUser = store.getters["Auth/user"];
    await this.updateCurrentUser({ ...currentUser, configuracao_id: franquia.id });
    limparDadosBasicos();
    router.push({ path: "/" });
  }

  async atualizarSenha(password, passwordConfirmation) {
    await Axios().put("/update-password", {
      password,
      password_confirmation: passwordConfirmation,
    });
    await this.syncUserWithStore();
    store.dispatch("Auth/verificarForcaDaSenha");
  }
}

export default new AuthService();
